import { isHttpUrl } from "@/utils/link";

/**
 * URLを開いて、PDFをダウンロードする。
 * @param url - 期限つきのダウンロードURL
 * @param fileName - 保存するファイル名
 * @throws http / https 以外のURL（javascript: など）は開かずに例外にする。呼び出し側でエラーを表示する
 */
export const startDownload = (url: string, fileName: string): void => {
  if (!isHttpUrl(url)) {
    throw new Error("ダウンロードURLのスキームが不正です");
  }
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  anchor.rel = "noreferrer";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
};
